<div class="share-buttons">
  @if (url) {
  <div class="share-buttons__list">
    @for (provider of providers; track trackByProvider($index, provider)) { @if
    (!disabledProvider?.includes(provider.sharebutton)) {
    <a
      (click)="action(provider, tooltip)"
      class="share-buttons__item"
      [shareButton]="provider.sharebutton"
      [url]="url"
      [title]="provider.sharebutton === 'email' ? emailSubject : ''"
      [description]="provider.sharebutton === 'email' ? emailBody : ''"
      (mouseenter)="$event.stopImmediatePropagation()"
      (mouseleave)="$event.stopImmediatePropagation()"
      [matTooltip]="copiedHint"
      matTooltipPosition="left"
      #tooltip="matTooltip">
      @if ( provider.sharebutton !== 'print' && provider.sharebutton !== 'email' && provider.sharebutton !== 'copy' ) {
      <mat-icon [svgIcon]="provider.icon"></mat-icon>
      } @if (provider.sharebutton === 'print') {
      <mat-icon>print</mat-icon>
      } @if (provider.sharebutton === 'email') {
      <mat-icon>mail</mat-icon>
      } @if (provider.sharebutton === 'copy') {
      <mat-icon>link</mat-icon>
      }
      <p class="share-buttons__name">{{ provider.name }}</p>
    </a>
    } }
  </div>
  }
</div>
